<template>
  <section v-if="!loading && items.length">
    <v-container>
      <TitleWidget>
        {{ title }}
      </TitleWidget>

      <v-row class="mt-6">
        <template v-for="(item, keyItems) in items">
          <v-col
            :key="keyItems"
            v-if="(mdOnly && keyItems <= 2) || !mdOnly"
            cols="6"
            md="4"
            lg="3"
          >
            <ArticleCard v-bind="item" />
          </v-col>
        </template>
      </v-row>

      <ButtonWidget
        class="mt-8 mt-md-10"
        color="primary"
        :to="path"
        align="center"
        text-color="white"
      >
        Ver mais
      </ButtonWidget>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ArticleCard from "../cards/ArticleCard.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "articles",
  path: "/eventos",
};

const _pagination = {
  itemsPerPage: 4,
};

const _data = {
  title: "Eventos",
  loading: true,
  path: _config.path,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, img, title }) => ({
        img,
        title,
        to: `${this.path}/${formatToURL(title)}-${id}`,
      }));
    },
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = {
        ..._pagination,
      };

      this.$rest(_config.mod)
        .get({ params })
        .finally(() => (this.loading = false));
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    ArticleCard,
    ButtonWidget,
  },
};
</script>
